var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelector(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2778_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2778_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13.9748C10.8667 13.9748 10.7417 13.954 10.625 13.9123C10.5084 13.8706 10.4 13.7998 10.3 13.6998L5.70005 9.0998C5.51672 8.91647 5.42505 8.68314 5.42505 8.3998C5.42505 8.11647 5.51672 7.88314 5.70005 7.6998C5.88338 7.51647 6.11672 7.4248 6.40005 7.4248C6.68338 7.4248 6.91672 7.51647 7.10005 7.6998L11 11.5998L14.9 7.6998C15.0834 7.51647 15.3167 7.4248 15.6 7.4248C15.8834 7.4248 16.1167 7.51647 16.3 7.6998C16.4834 7.88314 16.575 8.11647 16.575 8.3998C16.575 8.68314 16.4834 8.91647 16.3 9.0998L11.7 13.6998C11.6 13.7998 11.4917 13.8706 11.375 13.9123C11.2584 13.954 11.1334 13.9748 11 13.9748Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.93f81f14c6d6286dd8c50e788b7c971b.svg";
export { ForwardRef as ReactComponent };